import React from "react";

const StorePreviewShimmer = ({ size = 12 }) => {
    return (
        <div className="store-preview-shimmer">
            <div className="custom-container">
                <div className="shimmer user-shimmer">
                    <div className="wrappercard">
                        <div className="image-card animate"></div>
                        <div className="shimmercontant">
                            <div className="stroke animate title1"></div>
                            <div className="stroke animate title2"></div>
                            <div className="stroke animate title3"></div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {new Array(size).fill({}).map((a, index) => (
                        <div className="col-md-3">
                            <div className="shimmer product-shimmer">
                                <div className="wrappercard">
                                    <div className="image-card animate"></div>
                                    <div className="shimmercontant">
                                        <div className="stroke animate title1"></div>
                                        <div className="stroke animate title2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default StorePreviewShimmer;